export enum Locale {
  En = 'en-US',
  Fr = 'fr',
}
